import { ChevronLeft } from "lucide-react";
import type { ReactNode } from "react";
import { Link, useLocation } from "wouter";

type BackTo = { href: string; label: string };

type Props = {
  children: ReactNode;
  backTo?: BackTo;
};

export function PortalLayout({ children, backTo }: Props) {
  const [location] = useLocation();
  const fallbackBack: BackTo | null =
    location !== "/onboarding" ? { href: "/onboarding", label: "Voltar para minha jornada" } : null;
  const back = backTo ?? fallbackBack;
  return (
    <div className="mx-auto w-full max-w-3xl space-y-4">
      {back && (
        <Link
          href={back.href}
          className="inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground transition-colors"
          data-testid="portal-back-link"
        >
          <ChevronLeft className="h-4 w-4" />
          {back.label}
        </Link>
      )}
      {children}
    </div>
  );
}
